import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { ListItem, ListItemText } from '@material-ui/core';
import AddIcon from '@mui/icons-material/Add';

import CheckCircleIcon from 'assets/icons/check-circle.svg';
import { selectUser } from 'entities/user/selectors';
import Img from 'retired/Img';
import NonprofitLink from 'retired/NonprofitLink';
import { computeDonationProviderForNonprofit } from 'utils/computeDonationProviderForNonprofit';
import { getDonationProviderDisplayName } from 'utils/getDonationProviderDisplayName';

const Option = React.memo(({ nonprofit, add }) => {
  const user = useSelector(selectUser);
  const preferStripe = user?.organization?.settings?.get('preferStripe') || false;

  const locationObject = nonprofit.get('locationObject');
  const location = locationObject?.get('city')
    ? [
        locationObject.get('address'),
        locationObject.get('city'),
        locationObject.get('state') &&
          locationObject.get('postalCode') &&
          `${locationObject.get('state')} ${locationObject.get('postalCode')}`,
      ]
        .filter(Boolean)
        .join(', ')
    : '';

  const providerCode = computeDonationProviderForNonprofit(nonprofit, preferStripe);
  const providerName = getDonationProviderDisplayName(providerCode);
  const showPoweredBy = user?.isAdmin || false;

  return (
    <ListItem button onClick={() => add()} title="Select nonprofit">
      <AddIcon size="small" />
      <ListItemText
        primary={
          <>
            <NonprofitLink nonprofit={nonprofit.toJS()} />{' '}
            {nonprofit.get('ein') ? <>– EIN: {nonprofit.get('ein')}</> : null}
            {nonprofit.get('approved') && (
              <Img
                src={CheckCircleIcon}
                style={{ width: '20px', marginLeft: 6 }}
                alt="Approved"
                title="Approved"
              />
            )}
          </>
        }
        secondary={
          <>
            {location}
            {showPoweredBy && providerName && (
              <>
                <br />
                Powered by: {providerName}
              </>
            )}
          </>
        }
      />
    </ListItem>
  );
});
Option.propTypes = {
  add: PropTypes.func,
  nonprofit: PropTypes.object,
};

export default Option;
